import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WelcomePackService {

  constructor(private http: HttpClient) { }


  getCatalogueWelcomePack(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.WELCOME_PACK.GET_CATALOGUE_WELCOME_PACK + '/' + dataIn.catalogueId + '/welcomePack';

    return this.http.get(url);

  }

  getWelcomeBoxes(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.WELCOME_PACK.GET_WELCOME_BOXES + '/' + dataIn.welcomePackId + '/welcomeBoxes';

    return this.http.get(url);

  }

  getWelcomeFiles(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.WELCOME_PACK.GET_WELCOME_FILES + '/' + dataIn.welcomePackId + '/welcomeFiles';

    return this.http.get(url);

  }




}
